import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';

import FragmentNode from '../core/fragment-node';
import Engine, { FragmentProviderOptions } from '../engine';

import BaseFragment, { BaseFragmentProps, BaseFragmentState } from './base-fragment';

@AwesomeComponent({ name: 'Fragment', type: ComponentType.LAYOUT })
class StatefulFragment extends BaseFragment<BaseFragmentProps, BaseFragmentState> {
  state = {
    content: null,
    contextData: {},
    loaded: false,
    node: null,
  };

  provideFragment(engine: Engine, options: FragmentProviderOptions): FragmentNode {
    return engine.provideFragment(options);
  }
}

export default StatefulFragment;
